import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { inputStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            inputSelect: css`
                ${inputStyles()}
                
                &:disabled {
                    opacity: 0;
                }
            `,
        },
        buttonProps: {
            css: css`
                margin-top: ${sizeVariantValues.small.labelHeight}px;
            `,
        },
    },
};
